export const AGREEMENT_PROFESSIONAL_INVESTOR_FILE_INIT =
  'AGREEMENT_PROFESSIONAL_INVESTOR_FILE_INIT';
export const AGREEMENT_PROFESSIONAL_INVESTOR_FILE_ERROR =
  'AGREEMENT_PROFESSIONAL_INVESTOR_FILE_ERROR';
export const AGREEMENT_PROFESSIONAL_INVESTOR_FILE_SUCCESS =
  'AGREEMENT_PROFESSIONAL_INVESTOR_FILE_SUCCESS';
